import { render, staticRenderFns } from "./readed.vue?vue&type=template&id=851a32e0&scoped=true&"
import script from "./readed.vue?vue&type=script&lang=js&"
export * from "./readed.vue?vue&type=script&lang=js&"
import style0 from "./readed.vue?vue&type=style&index=0&id=851a32e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a32e0",
  null
  
)

export default component.exports